import {useTheme} from '@mui/material';
import {useBeneficiaryCard, usePersonalData} from 'presentation/hooks';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';

import {getUserInfoFromToken} from 'presentation/utils';
import {UseTelehealthSummarySectionGroupProps} from './types';

export function useTelehealthSummarySectionGroup({
	activeStep,
	stepLabels,
}: UseTelehealthSummarySectionGroupProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const {beneficiaryCardPlanData} = useBeneficiaryCard();
	const {currentEmail, currentPhone} = usePersonalData();
	const bookingTheme = useBookingTheme({flowType: FlowEnum.TELEHEALTH});
	const {cdUsuario} = getUserInfoFromToken();
	const {colors} = useTheme();

	const {isRebooking, specialtyCode, specialtyName} = bookingData;

	const isLastStep = activeStep === stepLabels.length - 1;
	const showSpecialtyField = activeStep >= 1 && !isLastStep;
	const showUnitField = activeStep >= 1 && !isLastStep;

	return {
		showSpecialtyField,
		bookingTheme,
		colors,
		cdUsuario,
		beneficiaryCardPlanData,
		currentEmail,
		currentPhone,
		isLastStep,
		isRebooking,
		specialtyCode,
		specialtyName,
		bookingData,
		showUnitField,
	};
}
